import AppDispatcher from './appDispatcher';

export default (actionType, data = null, name) => {
	AppDispatcher.handleViewAction({actionType, data, name});
};
